import { FIRST_NEGOTIATION } from './first-negotiation';
import { PRESSURE_POINT } from './pressure-point';
import { MID_SCENE } from './mid-scene';
import { HARD_NO } from './hard-no';
import { ENDING } from './ending';
import type { Scenario } from '../types';

export const SCENARIOS: Scenario[] = [
  FIRST_NEGOTIATION,
  PRESSURE_POINT,
  MID_SCENE,
  HARD_NO,
  ENDING,
];

export function getScenario(id: string): Scenario | undefined {
  return SCENARIOS.find((s) => s.id === id);
}
